import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { DoCheckIn } from './DoCheckIn';

export const CheckIn = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/do-check-in`} component={DoCheckIn} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/checkIn/CheckIn.tsx